module.exports = __webpack_public_path__ + "img/spins_2.c813e312.png";